// extracted by mini-css-extract-plugin
export var chip = "_ma-2";
export var chipBody = "_ma-8";
export var chipHeader = "_ma-9";
export var chipWithKind = "_ma-7";
export var icon = "_ma-3";
export var kind = "_ma-a";
export var remove = "_ma-5";
export var removeIcon = "_ma-6";
export var row = "_ma-0";
export var rowHistorical = "_ma-1";
export var text = "_ma-4";